import * as React from "react";
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import AuthService from "../../services/auth.service";
import { useNavigate } from "react-router-dom";

export function MenuAdmin() {
  const navigate = useNavigate();

  const logOut = () => {
    AuthService.logout();
    navigate("/login");
    window.location.reload();
  }

  return (
    <Navbar className="navbar navbar-expand-lg navbar-dark" expand="lg">
      <Container>
        <Nav className="me-auto">
          <Nav.Link className="mx-4" as={Link} to={{ pathname: "/admin_uploadImage" }}>Ajouter une image à la bannière</Nav.Link>
          <Nav.Link className="mx-4" as={Link} to={{ pathname: "/admin_dashboardBanner" }} >Modifier les images de la bannière </Nav.Link>
          <Nav.Link className="mx-4" as={Link} to={{ pathname: "/admin_dashboardSatellite" }} >Gestion Satellite </Nav.Link>
        </Nav>

        <Nav target="_blank">
          <Button variant="light" onClick={logOut}>Logout</Button>
        </Nav>
      </Container>
    </Navbar >
  );
}
export default MenuAdmin;